// extracted by mini-css-extract-plugin
export default {"button":"modalCustom_button__nKvI1","wrapper":"modalCustom_wrapper__S9C92","typography":"modalCustom_typography__H+NBn","button_wrapper":"modalCustom_button_wrapper__E2avu"};